import * as React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Nav from "./nav";
import Footer from "../admin/footer";
import axios from 'axios';
import { useState, useEffect } from "react";


const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));


export default function Dashboard() {
  const getInq = async (id)=> {
    const data = new FormData();
    data.append('id',id);
            axios({
              method: 'post',
              url: '/api_lock/agent/get_inq.php',
              data: data,
              headers: {'Content-Type': 'multipart/form-data'},
            })
              .then(s => {
                setList(s.data)
                console.log(s.data)
                console.log(id)
               ;
         
              })
              .catch(s => {
                console.log('here catch =>>', s);
              });
          };

  const getPhone = async (phone,id)=> {
    const data = new FormData();
        data.append("phone",phone)
        data.append("id",id)
            axios({
              method: 'post',
              url: '/api_lock/agent/get_phone_detail.php',
              data: data,
              headers: {'Content-Type': 'multipart/form-data'},
            })
              .then(s => {

                const a=s.data[0].msg
                var x="/view_inquiry?id="

                if(a=="new")
                {
                  alert(s.data[0].dis)


                }else if(a=="old")
                {
                  alert(s.data[0].dis)
                }else if(a=="dashboard"){
                  alert(s.data[0].dis)

                }else if(a=="view"){

                  window.location.replace(x+s.data[0].inq)

                }

                
                 
                
              
                
                
         
              })
              .catch(s => {
                console.log('here catch =>>', s);
              });
          };

 




  const View_time_update = async (inquiry_id,agent_id)=> {

    const data = new FormData();
    data.append('inquiry_id',inquiry_id);
    data.append('agent_id',agent_id);
        
            axios({
              method: 'post',
              url: '/api_lock/agent/view_time_update.php',
              data: data,
              headers: {'Content-Type': 'multipart/form-data'},
            })
              .then(s => { 
                console.log(s.data)
                getInq(JSON.parse(user)[0].id)

             
              })
              .catch(s => {
                console.log('here catch =>>', s);
              });
          };

  const [list,setList]=useState([])

  const [Reminder,setReminder]=useState([])

 
  const [phone,setPhone]=useState("")
  const [phoneError,setPhoneError]=useState("")

  const [user,setUser]=useState(null);

  useEffect(() => {
    const a=localStorage.getItem("Agent");
    if(a==null)
    {
     // window.location.replace("/login")
    }else{
      setUser(a)
      getInq(JSON.parse(a)[0].id);
      getInq_Reminder(JSON.parse(a)[0].id)
     
    }


  
  
  }, []);

  const getInq_Reminder = async (id)=> {
    const data = new FormData();
    data.append('agent_id',id);
    
            axios({
              method: 'post',
              url: '/api_lock/agent/reminder.php',
              data: data,
              headers: {'Content-Type': 'multipart/form-data'},
            })
              .then(s => {
                
                const se=s.data;
                se.sort((a, b) => {
                  return new Date(a.date_reminder) - new Date(b.date_reminder);
              });
                setReminder(se)
              
                
         
              })
              .catch(s => {
                console.log('here catch =>>', s);
              });
          };


          function getRemainingDays(targetDate) {
            const currentDate = new Date();
            const remainingTime = new Date(targetDate) - currentDate;
            
            // Convert remaining time from milliseconds to days
            const remainingDays = Math.ceil(remainingTime / (1000 * 60 * 60 * 24));
            
            return remainingDays;
        }




  return (
  <>

  <Nav />



    <div className="page-container" style={{backgroundColor:"#F9FBFD"}}>
        {/* Content Wrapper START */}
        <div className="main-content">
          
          <div className="row">




            <div className="col-md-6 col-lg-3">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <p className="m-b-0">Response Pending </p>
                      <h2 className="m-b-0">
                        <span>{list.length}</span>
                      </h2>
                    </div>
                    <div className="avatar avatar-icon avatar-lg avatar-blue">
                    <i class="anticon anticon-check"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div className="col-md-6 col-lg-3">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <p className="m-b-0">Reminder List </p>
                      <h2 className="m-b-0">
                      <span>{Reminder.length}</span>
                      </h2>
                    </div>
                    <div className="avatar avatar-icon avatar-lg avatar-red">
                      <i className="anticon anticon-bar-chart" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-6">
              <div className="card">
                <div className="card-body">
                <div className="row">
                    <div className='col-6'>
                      <p className="m-b-0">Search Example : 923058403240 </p>
                      </div></div>

                  <div className="row">
                    <div className='col-8'>
                    <input value={phone} onChange={(v)=>{
                      setPhone(v.target.value)
                    }} className='form-control' maxlength="12" placeholder='Phone No.' style={{borderColor:phoneError==""?'blue':'red'}} />
                      </div>
                    <div className='col-4'>
                    <button onClick={()=>{

                      if(phone.length===12)
                      {
                        setPhoneError("")
                        getPhone(phone,JSON.parse(user)[0].id)
                      }else{
                        setPhoneError("yes")
                      }
                      
                    }} class="btn btn-primary btn-tone m-r-5">Search</button>
                      </div>

                     
                     
                      
                 
                   
                  </div>
                </div>
              </div>
            </div>


          </div>
         
   


   
        

    <div className="card">
   <div style={{paddingTop:"10px",paddingLeft:"20px"}}>
   <h4>Received Inquiry <span onClick={()=>{getInq(JSON.parse(user)[0].id);}} ><i style={{color:"#FFC107"}}  className="anticon anticon-undo"></i> </span></h4>
   
   
   </div>
   <div className="card-body">
 <div>
      <div id="data-table_wrapper" className="dataTables_wrapper ">
      
        <div className="row">
          <div className="col-sm-12">
            <table
              id="data-table"
              className="table dataTable"
              role="grid"
              aria-describedby="data-table_info"
            >
              <thead>
                <tr role="row">
                  <th
                    className="sorting_asc">
                    ID
                  </th>
                  <th
                    className="sorting_asc">
                    Website
                  </th>
                  <th
                    className="sorting"
          
                  >
                    Inquiry
                  </th>
                  <th
                    className="sorting"
                   
          
                  >
                    Received
                  </th>
                  <th
                    className="sorting">
                    Study Course 
                  </th>
                  <th className="sorting">Country</th>
                  {/* <th className="sorting"> Ad/ch/In</th> */}
                  <th className="sorting">Account</th>
                  <th
                    className="sorting">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
      {
        list.map((v)=>(   
        

              <>
                <tr role="row" className="odd">
                  <td>{v.id} </td>
                  <td>{v.web}</td>
                  <td>{v.date_portal} {v.date_time}</td>
                  <td>{v.rec_time}</td>
                  <td>{v.makkah} </td>
                  <td>{v.madina}</td>
                  {/* <td>{v.adult==""?<></>:<b style={{color:"green"}}>{v.adult}</b>}{v.child==""?<></>:<b style={{color:"red"}}> {v.child}</b>}{v.infant==""?<></>:<b style={{color:"blue"}}> {v.infant}</b>}</td> */}
                  <td>
                  <HtmlTooltip
                  sx={{borderRadius: 2,  minWidth: 300,}}
        title={
          <>{v.url}</>
      
        }
      >
        <Button>{v.type_}</Button>
      </HtmlTooltip>
      </td>
      
     <td>
      <a target='black_' href={"/view_inquiry?id="+v.id}>
        <button onClick={()=>{
            
           


                     View_time_update(v.id,JSON.parse(user)[0].id)

                     
                    
                    
                  }} className="btn btn-warning m-r-5">View</button>
                 
                 </a>
                  </td>
                </tr>
           
               
              </>
           

      ))
      }
        </tbody>
        </table>
          </div>
        </div>
        
      </div>
    </div>
  
  </div>
      <div >


      
        
        
      </div>
      
    
    </div>


    <div className="card" style={{backgroundColor :"#696969"}}>
          <div style={{paddingTop:"10px",paddingLeft:"20px"}}>
<h4 style={{color :"white"}}>Reminder Alert  </h4>
   
   
   </div>
   <div className="card-body">
 <div>
      <div id="data-table_wrapper" className="dataTables_wrapper ">
      
        <div className="row">
          <div className="col-sm-12">
            <table
              id="data-table"
              className="table dataTable"
              role="grid"
              aria-describedby="data-table_info">
              <thead>
                <tr role="row">
                  <th
                    className="sorting_asc">
                    ID
                  </th>
                  <th
                    className="sorting_asc">
                    Website
                  </th>
                  <th
                    className="sorting"
          
                  >
                    Inquiry
                  </th>
                  <th
                    className="sorting"
                   
          
                  >
                    Received
                  </th>
                  <th
                    className="sorting">
                    Folllow Up
                  </th>
                 
                  <th className="sorting">Date</th>
                  <th className="sorting">Remaing Days</th>
                  <th className="sorting">Account</th>
                  <th
                    className="sorting">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
      {
        Reminder.map((v)=>(   
        

              <>
{
              
              
                <tr role="row" className="odd">
                  <td>{v.id} </td>
                  <td>{v.web}</td>
                  <td>{v.date_portal} {v.date_time}</td>
                  <td>{v.sender_time}</td>
                  <td>{v.agent_status}</td>
                  <td>{v.date_reminder}</td>
                  <td>
                    {  getRemainingDays(v.date_reminder)==0?"Today":getRemainingDays(v.date_reminder)<0?<div style={{color:'red'}}>Late {getRemainingDays(v.date_reminder)} Days</div>:<div style={{color:"green"}}>{getRemainingDays(v.date_reminder)} Days</div>}</td>
                  <td>
                  <HtmlTooltip
                  sx={{borderRadius: 2,  minWidth: 300,}}
        title={
          <>{v.url}</>
      
        }
      >
        <Button>{v.sender_type}</Button>
      </HtmlTooltip>
      </td>
      
     <td>
      <a target='black_' href={"/view_inquiry?id="+v.id}>
        <button 
        className="btn btn-warning m-r-5">View</button>
                 
                 </a>
                  </td>
                </tr>
              }
              
                
           
               
              </>
           

      ))
      }
        </tbody>
        </table>
          </div>
        </div>
        
      </div>
    </div>
  
  </div>
      <div >

      </div>
      
    
    </div>


        </div>
        {/* Content Wrapper END */}
        {/* Footer START */}
<Footer />
        {/* Footer END */}
      </div>
      
  </>
  );
}